/**
 * Reads the free-tier `/v1/projects/:projectId/reports/monthly?month=YYYY-MM`
 * view. Always populated — even when GSC/GA4 are not connected — so the
 * report page can show rank/audit/discovery signal alongside (or instead of)
 * the OAuth-dependent anomalies + recommendations.
 */
import { useQuery } from '@tanstack/react-query';
import type { MonthlyReportView } from '@seo/types';
import { apiGet } from '@/lib/api';

export function useMonthlyReportView(
  projectId: string | undefined,
  month: string | undefined,
) {
  return useQuery({
    queryKey: ['monthly-report-view', projectId, month],
    queryFn: () =>
      apiGet<MonthlyReportView>(
        `/v1/projects/${projectId}/reports/monthly?month=${month}`,
      ),
    enabled: Boolean(projectId && month),
    staleTime: 60_000,
    refetchOnWindowFocus: false,
  });
}

/** Extract YYYY-MM from a Report's period_start (e.g. '2026-06-30' -> '2026-06'). */
export function monthFromPeriodStart(periodStart: string): string {
  return periodStart.slice(0, 7);
}
